"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(path) {
  return window.location.hash.indexOf(path) >= 0;
};

exports["default"] = _default;